import React from 'react';
import * as MuiCore from '@material-ui/core';
import * as Icons from '@material-ui/icons';
import PhoneTextFieldWithFlag from 'ui/PhoneTextFieldWithFlag';

const TransferRecipientForm = ({ recipient, index, onChange, onRemove, showRemove }) => {
    const setField = (field, value) => onChange(recipient.id, field, value);

    return (
        <MuiCore.Box style={{ display: 'flex', flexDirection: 'column', gap: 12, marginBottom: 16 }}>
            <MuiCore.Box style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <MuiCore.Typography variant="subtitle1" style={{ fontFamily: 'Sofia-bold' }}>
                    Transfer Recipient {index + 1}
                </MuiCore.Typography>
                {showRemove && (
                    <MuiCore.IconButton onClick={() => onRemove(recipient.id)} color="secondary" size="small">
                        <Icons.Delete />
                    </MuiCore.IconButton>
                )}
            </MuiCore.Box>

            <MuiCore.TextField
                value={recipient.name}
                onChange={(e) => setField('name', e.target.value)}
                variant="outlined"
                placeholder="Enter recipient name"
                error={Boolean(recipient.nameError)}
                helperText={recipient.nameError || ''}
                inputProps={{ style: { fontFamily: 'Sofia' } }}
                InputLabelProps={{ style: { fontFamily: 'Sofia' } }}
                InputProps={{ style: { fontFamily: 'Sofia' } }}
            />

            <MuiCore.Box style={{ width: '100%' }}>
                <MuiCore.Typography variant="subtitle1" style={{ fontFamily: 'Sofia-bold' }}>
                    Phone Number
                </MuiCore.Typography>
                <PhoneTextFieldWithFlag
                    fullBorders
                    variant="outlined"
                    value={recipient.phone}
                    onPhoneNumberChange={(change) => setField('phone', change)}
                    isValid={(valid) => setField('isPhoneValid', valid)}
                />
                {recipient.phoneError && (
                    <MuiCore.Typography variant="caption" style={{ color: '#f44336', fontFamily: 'Sofia' }}>
                        {recipient.phoneError}
                    </MuiCore.Typography>
                )}
            </MuiCore.Box>
        </MuiCore.Box>
    );
};

export default TransferRecipientForm;